import { SET_WIDTH } from "../actions/types";
import _ from "lodash";

export default function(state = {}, action) {
  switch (action.type) {
    case SET_WIDTH: {
      return _.omit({ ...action.payload });
    }
    default:
      return state;
  }
}
